<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>회원 공간</p></li>
            <li><p>회원 홍보관</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>회원 홍보관</span>
          </h1>
        </div>
        <div class="page_con">
          <div class="table detail">
            <div class="row head">
              <div class="cell">
                <p class="left">
                  <span class="lock"></span>
                  <span class="board_ttl">{{ item.promotion.boardTitle }}</span>
                </p>
              </div>
              <div class="cell fix240">
                <p class="date">
                  {{ item.user.userId }}
                </p>
                <p class="date">
                  {{ $moment(item.promotion.regDate).format('YYYY.MM.DD') }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="cell detail_con">
                <div class="editor">
                  <!-- 홍보업체, 전화번호, 대표자명 위치는 PM님과 상의 후 다시 넣기 -->
                  <div> 홍보업체 : {{ item.promotion.company }}</div>
                  <div> 전화번호 : {{ item.promotion.phone }}</div>
                  <div> 대표자 명 : {{ item.promotion.representative }}</div>
                  <br><br>
                  <div v-html="item.promotion.contents"></div>
                  <!--div 꼭 넣어주세요!-->
                </div>
              </div>
            </div>
            <div class="row" v-if="item.filePaths.length > 0">
              <div class="cell file_up">
                <div class="file_up_ttl">
                  <span>첨부 파일</span>
                </div>
                <ul>
                  <li v-for="(item, index) in item.filePaths" :key="index">
                    <button v-on:click="fnDownloadFile(item)">{{ item.fileName }}</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="page_btn">
          <button class="btn" @click="() => $router.go(-1)">목록으로</button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'space-promotion-view',
  data: function() {
    const query = this.$route.query
    return {
      promotionNo: Number(query.promotionNo),
      item: {}
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData: async function() {
      const res = await this.$SpaceSvc.getMapPromotion({
        promotionNo: this.promotionNo
      })
      console.log('res', res)
      if (res.code === 1) {
        this.item = res.entity
      }
    },
    fnDownloadFile: function(item) {
      let params = {}
      params.fileName = item.fileName
      params.filePath = item.filePath
      this.$CommonSvc.downloadFile(params).then(res => {
        if (!this.$Util.isEmpty(item.fileName)) {
          const blob = new Blob([res.data], {
            type: res.data.type,
            encoding: 'UTF-8'
          })
          const a = document.createElement('a')
          a.href = URL.createObjectURL(blob)
          a.download = item.fileName
          a.target = '_blank'
          a.click()
        }
      })
    },
  }
}
</script>

<style scoped></style>
